module.exports = __webpack_public_path__ + "img/blimpy6.a64fc319.jpg";